import { inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { map, tap } from 'rxjs';
import { StorageService } from '../services/storage.service';
import { StoryblokService } from '../services/storyblok.service';

export const storyblokStoryResolver = (route: ActivatedRouteSnapshot) => {
  const storage = inject(StorageService);
  const path = route.url.map(segment => segment.path).join('/') || 'home';
  return inject(StoryblokService)
    .getStory(path, route)
    .pipe(
      map(resp => (resp && resp.story) || (false as const)),
      tap(story => {
        const promotionCode = story && story.content.promotionCode;
        if (promotionCode) storage.set('promo', promotionCode);
      })
    );
};
